import { RelationshipResourceType } from '@cognite/sdk';

export const ALL_RELATIONSHIP_RESOURCE_TYPES: RelationshipResourceType[] = [
  'asset',
  'event',
  'file',
  'sequence',
  'timeSeries',
];
